module.exports = __webpack_public_path__ + "static/media/UNI-201-badge.0d850266.svg";